// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"1816":"6be047972552748d","2235":"e2e8d998c921cce1","3465":"284ebe54142071aa","3872":"cfda9219f1d45a0d","5085":"656812152ec07281","5724":"807c5e7bf1cbe3bd","8385":"3825cf391941bf2a"}[chunkId] + ".js";
};